module.exports = "/assets/08fa51aa311dc9c2e605b5770631496b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/IX.png
// module id = 1490
// module chunks = 0